import { render, staticRenderFns } from "./CaseMainFunctionIconDiv.vue?vue&type=template&id=201ab462"
import script from "./CaseMainFunctionIconDiv.vue?vue&type=script&lang=js"
export * from "./CaseMainFunctionIconDiv.vue?vue&type=script&lang=js"
import style0 from "./CaseMainFunctionIconDiv.vue?vue&type=style&index=0&id=201ab462&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports